import { FILTER_OPERATOR_ARITY, type FilterOperator, type ScalarValue } from '@aibi/contracts';
import type { FieldDescriptor } from '../../model/field-catalog';

export const OPERATOR_LABELS: Readonly<Record<FilterOperator, string>> = {
  eq: 'es igual a',
  neq: 'es distinto de',
  in: 'es uno de',
  'not-in': 'no es ninguno de',
  gt: 'mayor que',
  gte: 'mayor o igual que',
  lt: 'menor que',
  lte: 'menor o igual que',
  between: 'entre',
  contains: 'contiene',
  'starts-with': 'empieza por',
  'ends-with': 'termina en',
  'is-null': 'esta vacio',
  'is-not-null': 'no esta vacio',
};

const DIMENSION_OPERATORS: readonly FilterOperator[] = [
  'in',
  'not-in',
  'eq',
  'neq',
  'contains',
  'starts-with',
  'ends-with',
  'gt',
  'gte',
  'lt',
  'lte',
  'between',
  'is-null',
  'is-not-null',
];

const MEASURE_OPERATORS: readonly FilterOperator[] = [
  'gt',
  'gte',
  'lt',
  'lte',
  'between',
  'eq',
  'neq',
];

export const operatorsFor = (field: FieldDescriptor | undefined): readonly FilterOperator[] =>
  field?.kind === 'measure' ? MEASURE_OPERATORS : DIMENSION_OPERATORS;

export const takesValues = (operator: FilterOperator): boolean =>
  FILTER_OPERATOR_ARITY[operator][1] > 0;

const isNumericField = (field: FieldDescriptor | undefined): boolean =>
  field?.kind === 'measure' || field?.dataType === 'integer' || field?.dataType === 'decimal';

/** Convierte el texto editado ("a, b, c") en valores tipados segun el campo. */
export function parseFilterValues(text: string, field: FieldDescriptor | undefined): ScalarValue[] {
  const parts = text
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part !== '');
  if (!isNumericField(field)) return parts;
  return parts.map((part) => {
    const value = Number(part);
    return Number.isNaN(value) ? part : value;
  });
}

export const formatFilterValues = (values: readonly ScalarValue[]): string =>
  values.map((value) => (value === null ? '' : String(value))).join(', ');
